import _ from 'lodash';
import React from 'react';
import { MdSave } from 'react-icons/md';
import Crud from '~/components/crud';
import { formats } from '~/helper';
import useErpVersion from '~/view-data/use-erp-versions';
import { ErpVersionForm, ErpVersionSchema } from '~/views/erp-versions/form';
import { Container } from '~/views/erp-versions/styles';
import CellStatus from '~/components/datatable/cell-status';
import { SubtitleItem, SubtitleBox } from '~/components/datatable/subtitle';
import { red, green } from '~/components/mixins/color';

const columns = [
  {
    name: '# Nome',
    selector: 'name',
    cell: (row) => {
      return (
        <CellStatus title={row.name} color={row.active ? green.hex() : red.hex()}>
          <strong>{row.name}</strong>
        </CellStatus>
      );
    },
  },
  {
    name: 'Versão de',
    selector: 'from',
    center: true,
    width: '140px',
    format: (row) => _.get(row, 'from')
  },
  {
    name: 'Versão até',
    selector: 'from',
    center: true,
    width: '140px',
    format: (row) => _.get(row, 'to')
  },
  {
    name: 'Cadastrada em',
    selector: 'createdAt',
    hide: 'md',
    width: '140px',
    format: (row) => formats.dateTimeZone(_.get(row, 'createdAt'), 'dd/MM/yyyy HH:mm')
  }
];

function Profile({ acls }) {
  const { state, actions } = useErpVersion(),
    canWrite = acls.includes('W');

  return (
    <Container>
      <SubtitleBox bottom={35} left={100}>
        <span>Legenda:</span>
        <SubtitleItem color={green.hex()}>Ativa</SubtitleItem>
        <SubtitleItem color={red.hex()}>Inativa</SubtitleItem>
      </SubtitleBox>

      <Crud
        columns={columns}
        formTitle={(data) => (_.get(data, 'id')) ? `Versão de ERP #${data.id}` : `Versão de ERP`}
        emptyText='Nenhuma versão de ERP encontrada'
        data={state.data || {}}
        hideAdd={!canWrite}
        tableLoading={state.loading}
        formLoading={state.formLoading}
        onChangePage={actions.pageChange}
        onRowClicked={actions.load}
        formOptions={{
          validationSchema: ErpVersionSchema,
          initialValues: state.model,
          initialTouched: { active: true },
        }}
        renderForm={(args) => (
          <ErpVersionForm
            {...args}
            previewMode={!canWrite}
          />
        )}
        actions={[
          {
            label: 'Salvar',
            icon: MdSave,
            isSubmit: true,
            isDisabled: ({ isValid }) => !isValid || !canWrite,
            action: actions.createOrUpdate,
          },
        ]}
      />
    </Container>
  );
}

export default Profile;
